import { Submit } from 'libs/form/Submit';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';
import { Button, Stack } from 'libs/ui';

interface Props {
  onClose: () => void;
  submitLabel: string;
  backLabel?: string;
}

export const FooterActions = ({ onClose, submitLabel, backLabel }: Props) => {
  const { t } = useTranslation();
  const { submitDisabled } = useFormContext();

  return (
    <Stack spacing={8}>
      <Submit
        fullWidth
        disabled={submitDisabled}
        label={submitLabel}
        mode="standard"
      />
      <Button
        fullWidth
        label={backLabel ?? t('client.client.withdrawalAccounts.backButton')}
        mode="text"
        onClick={onClose}
      />
    </Stack>
  );
};
